import { useState } from "react";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { fmtDate } from "../SuperHeader";
import { useAdminFetch, TabState } from "../useAdminFetch";
import Pager from "../Pager";

const SAFE_TARGET_KEYS = ["user_id", "email", "lead_id", "contact_id", "conversation_id", "campaign_id", "search_id"];

export default function ActivityTab({ cid }) {
  const [page, setPage] = useState(1);
  const { data, error, loading } = useAdminFetch("/admin/audit-logs", { company_id: cid, page, page_size: 25 });
  return (
    <Card className="p-4 border-slate-200 space-y-3" data-testid="activity-tab">
      <TabState loading={loading && !data} error={error} empty={data?.items.length === 0} emptyText="No activity recorded for this company." testid="activity">
        <div className="overflow-x-auto">
          <table className="w-full text-sm min-w-[720px]">
            <thead className="bg-slate-50 text-xs uppercase text-slate-600"><tr><th className="p-2 text-left">When</th><th className="p-2 text-left">Actor</th><th className="p-2 text-left">Action</th><th className="p-2 text-left">Target</th><th className="p-2 text-left">Result</th></tr></thead>
            <tbody>{(data?.items || []).map((a, i) => (
              <tr key={i} className="border-t border-slate-100" data-testid="activity-row">
                <td className="p-2 text-xs text-slate-500 whitespace-nowrap">{fmtDate(a.at)}</td>
                <td className="p-2 text-xs">{a.actor_email || "system"}<div className="text-[10px] text-slate-400">{a.actor_role}</div></td>
                <td className="p-2 text-xs font-medium">{a.action.replaceAll("_", " ")}</td>
                <td className="p-2 text-[11px] text-slate-600">{SAFE_TARGET_KEYS.filter((k) => a.target?.[k]).map((k) => `${k}: ${a.target[k]}`).join(" · ") || "—"}</td>
                <td className="p-2"><Badge variant="outline" className="text-[10px]">{a.meta?.result || "recorded"}</Badge>{a.meta?.reason && <div className="text-[10px] text-slate-500">{a.meta.reason}</div>}</td>
              </tr>))}</tbody>
          </table>
        </div>
      </TabState>
      {data && data.total > 0 && <Pager page={data.page} pages={data.pages} total={data.total} onPage={setPage} testid="activity-pager" />}
    </Card>
  );
}
